// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"external-link-module__currentPage___14rsg"};